import { tourPoiSelectionChangedEventName, type TourPoiSelectionRequest, type TourPoiSelectionSnapshot } from "./TourPoiSelectionEvents";

export class TourPoiSelectionState {
    private activeScope: string | null = null;
    private snapshot: TourPoiSelectionSnapshot | null = null;
    private revision = 0;
    private seededPages = new WeakSet<HTMLScriptElement>();

    constructor(private readonly onChange: (value: TourPoiSelectionSnapshot | null) => void) {}

    activateScope(tourContextKey: string | null): void {
        const scope = tourContextKey?.trim() || null;
        if (scope === this.activeScope) return;
        this.activeScope = scope;
        this.snapshot = null;
        this.seededPages = new WeakSet();
        this.revision += 1;
        this.onChange(null);
    }

    select(request: TourPoiSelectionRequest): boolean {
        const scope = typeof request.tourContextKey === "string" ? request.tourContextKey.trim() : "";
        const poiId = request.poiId === null ? null : typeof request.poiId === "string" ? request.poiId.trim() : "";
        if (!scope || scope !== this.activeScope || poiId === "") return false;
        if (this.snapshot?.poiId === poiId && this.snapshot.origin === request.origin) return true;
        this.revision += 1;
        this.snapshot = { tourContextKey: scope, poiId, origin: request.origin, revision: this.revision };
        this.onChange(this.snapshot);
        return true;
    }

    getSnapshot(tourContextKey: string): TourPoiSelectionSnapshot | null {
        return tourContextKey === this.activeScope ? this.snapshot : null;
    }

    getRevision(): number { return this.revision; }

    seedPage(tourContextKey: string, poiId: string | null, contextElement: HTMLScriptElement, isPreview: boolean): void {
        if (isPreview || tourContextKey !== this.activeScope || this.seededPages.has(contextElement)) return;
        this.seededPages.add(contextElement);
        if (poiId !== null) this.select({ tourContextKey, poiId, origin: "page" });
    }
}

const states = new WeakMap<HTMLElement, TourPoiSelectionState>();

export function getTourPoiSelectionState(document: Document): TourPoiSelectionState | null {
    const shell = document.getElementById("smartguide-tour-tray");
    if (!shell) return null;
    let state = states.get(shell);
    if (!state) {
        state = new TourPoiSelectionState(snapshot => {
            document.dispatchEvent(new CustomEvent(tourPoiSelectionChangedEventName, { detail: snapshot }));
        });
        states.set(shell, state);
    }
    return state;
}
